import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios';
import "./modules/filters"; // filter modules
import "./modules/directives"; // directive module
import "./assets/css/style.css";
import 'hls.js';


import VueProgressiveImage from 'vue-progressive-image'
Vue.use(VueProgressiveImage)

import VuePaginate from 'vue-paginate';
Vue.use(VuePaginate);

import VueAPlayer from 'vue-aplayer';
VueAPlayer.disableVersionBadge = true

import VueScrollTo from 'vue-scrollto';
Vue.use(VueScrollTo, {
  duration: 500,
  easing: "ease",
  offset: 0,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})

import vSelect from 'vue-select'
Vue.component('v-select', vSelect)

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)

import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)

Vue.config.productionTip = false
axios.defaults.headers.post.Authorization = "Basic c2V6ZW46bmloYXQ=";

if (!Math.trunc) {
  Math.trunc = function (v) {
    v = +v;
    if (!isFinite(v)) return v;

    return (v - v % 1) || (v < 0 ? -0 : v === 0 ? v : 0);

  };
}
(function (arr) {
  arr.forEach(function (item) {
    if (item.hasOwnProperty('remove')) {
      return;
    }
    Object.defineProperty(item, 'remove', {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function remove() {
        if (this.parentNode !== null)
          this.parentNode.removeChild(this);
      }
    });
  });
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')